import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Table, Card, Button } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { BiLink, BiFile, BiTrash, BiLoader, BiPlus, BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import RadioBtn from "../../components/RadioBtn";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst';
import toastNotify from "../../utils/toastNotify";
import JSZip from "jszip";
import { converToBase64 } from "../../utils/common";
import SelectField from "../../components/textField/SelectField";
import Textfield from "../../components/textField/TextField";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import FetchDynamicColumn from "./FetchDynamicColumn";
import { handleDynamicColumnValue } from "../../redux/ticket";
import { useDispatch } from "react-redux";
import moment from "moment";
import Checkbox from "../../components/checkBox/Checkbox";
import Loader from "../../components/Loader";
import Select, { components } from 'react-select';
import { exceptionLog } from "../../utils/common";
import ArticleDtlMdl from "./ArticleDtlMdl";
import Editor from "../../components/textEditor/Editor";
import { useParamters } from "../../hooks/hooks";
import { checkFileMimeType } from "../../apiService/apiService";

const { ValueContainer, Placeholder }: any = components;

const CustomValueContainer: React.FC<any> = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};


type categoryDataProps = {
  CardDetail: string,
  CategoryName: string,
  CategoryType: string,
  TranCode: string,
  TranDetail: string,
}

type subCategoryDataProps = {
  CardDetail: string,
  CategoryCode: string,
  CategoryName: string,
  SubCategoryName: string,
  TranCode: string,
  TranDetail: string,
}

type branchDataProps = {
  BranchCode: string,
  BranchName: string,
}

const Createticket = () => {
  const [isTemplate, setIsTemplate] = useState<boolean>(false);
  const [addTicketLoader, setAddTicketLoader] = useState<boolean>(false);

  const [selectCategory, setSelectCategory] = useState<string>('');
  const [selectSubCategory, setSelectSubCategory] = useState<string>('');
  const [getCategoryData, setGetCategoryData] = useState<categoryDataProps[]>([]);
  const [getSubCategoryData, setGetSubCategoryData] = useState<subCategoryDataProps[]>([]);
  const [getBranchData, setGetBranchData] = useState<branchDataProps[]>([]);
  const navigate = useNavigate();
  const [dynamicColumnData, setDynamicColumnData] = useState<any[]>([]);
  const [getTemplateDropdownData, setGetTemplateDropdownData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [isArticleLoader, setIsArticleLoader] = useState<boolean>(false);
  const [articleList, setArticleList] = useState<{ Description: string, Topic: string, TranCode: string, PublishBy?: string, UpdatedDate?: string }[]>([]);
  const [selectedArticle, setSelectedArticle] = useState<any>();
  const [isArticleDtl, setIsArticle] = useState(false);
  const [fixedDynamicColumns, setFixedDybamicColumns] = useState<any>(null);

  const parameters = useParamters(["7003", "7007", "7011", "8001", "8002", "7006", "8005", "7014", "8003", "8006"]);

  const ticketSubCategoryMandentoryFlag = parameters.find((items: any) => items.paraCode === "7003")?.paraValue;
  const bypassToMimeType = parameters.find((items: any) => items.paraCode === "7006").paraValue;
  const attechmentSize = parameters.find((items: any) => items.paraCode === "7011").paraValue;
  const transactionRowLimit = parameters.find((items: any) => items.paraCode === "7007").paraValue;
  const isShowBranchCombo = parameters.find((items: any) => items.paraCode === "7014").paraValue;
  const defaultPriority = parameters.find((items: any) => items.paraCode === "8001")?.paraValue;
  const defaultCategoryType = parameters.find((items: any) => items.paraCode === "8002")?.paraValue;
  const ticketTypeSequence = defaultCategoryType === "S" ? [1, 2] : [2, 1];
  const defaultCustomerType = parameters.find((items: any) => items.paraCode === "8003")?.paraValue;
  const defaultClassification = parameters.find((items: any) => items.paraCode === "8005")?.paraValue;
  const attachmentMandatory = parameters.find((items: any) => items.paraCode === "8006")?.paraValue;

  const [selectTicketType, setSelectTicketType] = useState<any>(defaultCategoryType || "S");
  const [selectCustomerType, setSelectCustomerType] = useState<string>(defaultCustomerType || 'Y');

  // get category dropdown.
  const fetchCategories = async () => {
    try {
      const payload = {
        CustomerType: selectCustomerType,
        CategoryType: selectCustomerType === "N" ? "S" : selectTicketType,
      };
      const config = {};
      await makeRequest('POST', urls.getCategoryDropdown, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setGetCategoryData(response);
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get category dropdown", "N");
      }
    }
  };

  // get sub-category dropdown.
  const fetchSubCategories = async () => {
    try {
      const payload = {
        CustomerType: selectCustomerType,
        CategoryType: selectCustomerType === "N" ? "S" : selectTicketType,
        CategoryCode: selectCategory,
      };
      const config = {};
      await makeRequest('POST', urls.getSubCategoryDropdown, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setGetSubCategoryData(response);
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get sub-category dropdown", "N");
      }
    }
  };

  // get branch dropdown.
  const fetchBranch = async () => {
    try {
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.getBranchDropdown, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setGetBranchData(response);
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get branch dropdown", "N");
      }
    }
  };

  const fetchTemplate = async () => {
    try {
      const payload = {};
      const config = {};
      await makeRequest("POST", urls.getTicketTemplateCombo, payload, config).then((result) => {
        if (result.STATUS === '0') {
          setGetTemplateDropdownData(result.RESPONSE);
        } else {
          setGetTemplateDropdownData([]);
          result.MESSAGE !== "No data found" && toastNotify(`Template : ${result.MESSAGE}`, "error");
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get ticket template dropdown", "N");
      }
    }
  };


  useEffect(() => {
    if (isTemplate) {
      fetchTemplate();
    }
  }, [isTemplate]);


  // This function dynamic column map with master
  const setArrayData2 = (existingColumnCd: string, arrData: any, subColumnData: any, SrCode: string, value: string): any => {
    var updateedData = [...arrData]
    for (var i in updateedData) {
      if (updateedData[i].ColumnCode === existingColumnCd) {
        updateedData[i] = { ...updateedData[i], SubDynamicColumnData: subColumnData, ColumnValue: value };
      } else {
        if (updateedData[i].SubDynamicColumnData !== undefined) {
          updateedData[i] = { ...updateedData[i], SubDynamicColumnData: setArrayData2(existingColumnCd, arrData[i].SubDynamicColumnData, subColumnData, SrCode, value) };
        }
      }
    };
    setDynamicColumnData([...updateedData]);
    return updateedData;
  };

  // ----------------------------------------- this funcation fetch dynamic column dropdown start --------------------------------------
  const fetchDynamicColumn = async (ColumnCode?: any, SrCode?: any, value?: any, flag?: string) => {
    try {
      const payload = {
        CategoryCode: selectCategory,
        SubCategoryCode: selectSubCategory,
        ColumnFlag: flag || "M",
        TicketType: flag === "F" ? selectTicketType : "",
        CustType: selectCustomerType || "",
        RefNo: ColumnCode || "",
        OptRefNo: SrCode || "",
      };

      const config = {};

      await makeRequest("POST", urls.getTicketDynamicColumns, payload, config).then((result) => {
        if (result.STATUS === '0') {
          if (result.RESPONSE.length === 0) return;

          if (flag !== "D") {
            const addedColumnValue = result.RESPONSE.map((items: any) => {
              return ({
                ...items,
                SrCode: "",
                ColumnValue: "",
                Details: [],
                flag: flag || "M"
              })
            });

            if (flag === "F") {
              setFixedDybamicColumns(addedColumnValue)
              setDynamicColumnData(addedColumnValue);
            } else {
              if (fixedDynamicColumns) {
                setDynamicColumnData([...fixedDynamicColumns, ...addedColumnValue]);
              } else {
                setDynamicColumnData([addedColumnValue]);
              }
            }
          } else {
            const addedColumnValue = result.RESPONSE.map((items: any) => {
              return ({
                ...items,
                ColumnValue: "",
                SubDynamicColumnData: [],
                ColumnId: ColumnCode,
                flag: flag || "M"
              })
            });
            var arrData = dynamicColumnData;
            setArrayData2(ColumnCode, arrData, addedColumnValue, SrCode, value);
          }
        } else {
          if (flag === "F") {
            setFixedDybamicColumns([])
            setDynamicColumnData([]);
          } else {
            var arr = dynamicColumnData;
            const addedColumnValue: any = [];
            setArrayData2(ColumnCode, arr, addedColumnValue, SrCode, value);
          }
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get ticket dynamic column", "N");
      }
    }
  };

  const filteredFixedInputs = () => {
    const filterData = [];
    for (let i = 0; i < dynamicColumnData.length; i++) {
      for (let j = 0; j < fixedDynamicColumns.length; j++) {
        if (dynamicColumnData[i] === fixedDynamicColumns[j]) {
          filterData.push(dynamicColumnData[i])
        }
      }
    }
    return filterData;
  }

  useEffect(() => {
    if (selectCategory === '') {
      const filterFixedInputs = filteredFixedInputs();
      setDynamicColumnData(filterFixedInputs);
    }
  }, [selectCategory]);


  // call api function of category 
  useEffect(() => {
    const handleData = async () => {
      await fetchCategories();
      await fetchBranch();
      await fetchDynamicColumn("", "", "", "F")
    };
    handleData();
  }, [selectCustomerType, selectTicketType]);

  // ----------------------------------------- this funcation fetch dynamic column dropdown end --------------------------------------

  const fetchArticles = async () => {
    try {
      setIsArticleLoader(true);
      const payload = {
        CategoryCode: selectCategory,
        SubCategoryCode: selectSubCategory,
        ArticleType: "S",
      };

      const config = {};

      await makeRequest("POST", urls.getArticleList, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setArticleList(response);
        } else {
          setArticleList([]);
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get article list", "N");
      }
    } finally {
      setIsArticleLoader(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (selectCategory !== '' || selectSubCategory !== "") {
        if (getCategoryData.length !== 0) {
          await fetchSubCategories();
          await fetchDynamicColumn();
          await fetchArticles();
        }
      } else {
        const filterFixedInputs = filteredFixedInputs();
        setDynamicColumnData(filterFixedInputs);
        setArticleList([]);
      }
    })();
  }, [selectCategory, selectSubCategory, selectCustomerType]);


  // --------------------- Here write method for dynamic column in this manage dynamic column's and get data start ----------------------



  // This function help to get value form inputs
  const setDynamciColumn = (existingColumnCd: string, arrData: any, value: string): any => {
    var updateedData = [...arrData]
    for (var i in updateedData) {
      if (updateedData[i].ColumnCode === existingColumnCd) {
        updateedData[i] = { ...updateedData[i], ColumnValue: value };
      } else {
        if (updateedData[i].SubDynamicColumnData !== undefined) {
          updateedData[i] = { ...updateedData[i], SubDynamicColumnData: setDynamciColumn(existingColumnCd, arrData[i].SubDynamicColumnData, value) };
        }
      }
    }
    return updateedData;
  };

  // This function help to get value form inputs
  const getDynamicInputColumnValue = (ColumnCode?: any, value?: any): any => {
    var arrData = dynamicColumnData;
    const finalData = setDynamciColumn(ColumnCode, arrData, value);
    setDynamicColumnData([...finalData]);
  }

  // ------------------------------------------- here set value for other component section --------------------------------------------------------

  useEffect(() => {
    dispatch(handleDynamicColumnValue(getDynamicInputColumnValue));
  });

  const attanchmentRef = useRef<any>(null);
  const attachfiles = () => {
    attanchmentRef.current.click();
  };


  // ------------------------------------------- here Verify selected file start --------------------------------------------------------

  const [multiFile, setMultiFile] = useState<any[]>([]);

  const handleMultiFile = (e: React.ChangeEvent<any>) => {
    const files = e.target.files;
    let fileSize: any = 0;
    if (files.length > 0) {

      Array.from(files).forEach((file: any) => {
        fileSize = parseFloat(fileSize) + parseFloat((file.size / 1048576).toFixed(2));
      });

      if (Number(fileSize) > Number(attechmentSize)) {
        setMultiFile([]);
        return toastNotify(`File size less then ${attechmentSize} MB`, 'error');
      } else {
        Array.from(files).forEach((file: any) => {
          const reader: any = new FileReader();
          reader.onloadend = () => {
            let mimeType: any;
            if (bypassToMimeType === "N" || file?.type !== "text/plain") {
              mimeType = checkFileMimeType(reader);
            }

            if (mimeType === 'unknown' || bypassToMimeType === "N") {
              return toastNotify('Invaid file format', 'error');
            } else if (Number(fileSize) > Number(attechmentSize)) {
              return toastNotify(`File size less then ${attechmentSize} MB`, 'error');
            };
            setMultiFile((prevent: any) => [...prevent, file]);
          };
          reader.readAsArrayBuffer(file);
        });
      }
    };
  };


  // ------------------------------------------- here convert zip and base64 start --------------------------------------------------------
  // in thisfunction convert zip and base64
  const generateZipFile = async () => {
    const zip = new JSZip();
    if (multiFile.length > 0) {
      multiFile.forEach((items) => {
        zip.file(items.name, items);
      });
      const content: any = await zip.generateAsync({ type: 'blob' });
      const base64: any = await converToBase64(content);
      return base64.split(",")[1];
    } else {
      return '';
    }
  };

  function flattenArray(arr: any) {
    let dynamicColumnDataForSend: any = [];

    arr.forEach((item: any) => {
      dynamicColumnDataForSend.push({ ColumnValue: item.ColumnType !== "DATE" ? item.ColumnValue : moment(item.ColumnValue).format('YYYY-MM-DD'), ColumnCode: item.ColumnCode, ColumnNm: item.LabelName, ColumnRequired: item.Required });
      if (item.SubDynamicColumnData && item.SubDynamicColumnData.length > 0) {
        dynamicColumnDataForSend = dynamicColumnDataForSend.concat(flattenArray(item.SubDynamicColumnData));
      }
    });
    return dynamicColumnDataForSend;
  }
  // ------------------------------------------- here called add ticket API start --------------------------------------------------------

  // in this function call add ticket api.
  const addTicket = async (val: any, resetForm: any) => {

    if (val.ticketType === "T") {
      for (var i in val.transcationDtl) {
        if (val.transcationDtl[i].TranRefNo === "" || val.transcationDtl[i].TranAmount === "" || val.transcationDtl[i].TranDate === "") {
          return toastNotify(`Transaction Details is required`, 'error');
        }
      };
    }

    for (var j in flattenArray(dynamicColumnData)) {
      if (flattenArray(dynamicColumnData)[j].ColumnRequired === "Y") {
        if (flattenArray(dynamicColumnData)[j].ColumnValue === "") {
          return toastNotify(`${flattenArray(dynamicColumnData)[j].ColumnNm} is required field`, 'error');
        }
      }
    };

    try {
      setAddTicketLoader(true);
      const attechFile = await generateZipFile();

      if (attachmentMandatory === "Y" && attechFile === "") {
        return toastNotify('Attachment is mandatory', 'error');
      }

      const changeTrnsactionData = val.transcationDtl.map((items: any) => {
        return ({
          ...items,
          TranDate: moment(items.TranDate).format('YYYY-MM-DD')
        })
      });

      const dynamicInputData = flattenArray(dynamicColumnData).filter((items: any) => items.ColumnValue !== "")

      const payload = {
        CategoryCode: val.categoryValue,
        SubCategoryCode: val.subCategoryValue || "0",
        TicketSubject: val.subject,
        TicketDescription: val.ticketDescription,
        TicketType: val.ticketType,
        BankCustomer: val.customerType,
        TicketPriority: val.priorityValue,
        BranchCode: val.branchValue,
        ClassificationCode: val.classificationValue,
        ZipBase64: attechFile,
        DynamicColumn: dynamicInputData.length > 0 ? dynamicInputData.map((data: any) => ({ ColumnValue: data.ColumnValue, ColumnCode: data.ColumnCode })) : [],
        TransactionDetail: val.ticketType === "T" ? changeTrnsactionData : [],
      };
      const config = {};
      await makeRequest('POST', urls.addTicket, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          resetForm();
          setMultiFile([]);
          navigate("/tickets");
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Add ticket", "N");
      }
    } finally {
      setAddTicketLoader(false);
    }
  };


  const initialValues = {
    customerType: defaultCustomerType || 'Y',
    ticketType: defaultCategoryType || "S",
    categoryValue: "",
    categoryLabel: "",
    subCategoryValue: "",
    subCategoryLabel: "",
    branchValue: '',
    branchLabel: '',
    classificationValue: defaultClassification,
    classificationLabel: (defaultClassification === "F" && "Feature") || (defaultClassification === "Q" && "Question") || (defaultClassification === "P" && "Problem") || (defaultClassification === "O" && "Other"),
    templateValue: "",
    templateLabel: "",
    subject: "",
    ticketDescription: "",
    priorityValue: defaultPriority,
    priorityLabel: (defaultPriority === "L" && "Low") || (defaultPriority === "M" && "Medium") || (defaultPriority === "H" && "High"),
    attachFile: [],
    transcationDtl: [{ TranRefNo: '', TranAmount: '', TranDate: undefined }],
    agreeTicket: ""
  };

  const validation = Yup.object({
    categoryValue: Yup.string().required("Category is a required field"),
    subCategoryValue: ticketSubCategoryMandentoryFlag === "Y" ? Yup.string().required("Sub Category is a required field") : Yup.string(),
    branchValue: selectCustomerType === "Y" && isShowBranchCombo === "Y" ? Yup.string().required("Branch is a required field") : Yup.string(),
    subject: Yup.string().required("Subject is a required field"),
    ticketDescription: Yup.string().required("Description is a required field"),
    priorityValue: Yup.string().required("Priority is a required field"),
    classificationValue: Yup.string().required("Classification is a required field"),
  });


  return (
    <div>
      <div className="mb-3 d-flex align-items-center">
        <div>
          <h2 className="text-base fw-semibold mb-0">Create Ticket</h2>
        </div>
        {window.location.pathname === "/tickets/createticket" &&
          <Button variant="outline-secondary ms-auto" className="btn-sm" onClick={() => navigate("/tickets")}>
            <BiArrowBack className="me-2" />
            Back
          </Button>
        }
      </div>

      <Card>
        <Card.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={(values, { resetForm }) => {
              if (values.agreeTicket) {
                addTicket(values, resetForm);
              } else {
                toastNotify("Please Select Agree Terms &  condition", 'error');
              }
            }}
          >
            {({ values, handleBlur, handleChange, handleSubmit, setFieldValue, resetForm, validateForm, errors }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={9}>
                      <Row>
                        <Col md={6}>
                          <label className='text-xs text-slate-500 required'>Customer Type</label>
                          <div className="d-flex">
                            <RadioBtn
                              label="Existing Customer"
                              name="customerType"
                              className="me-3"
                              value="Y"
                              checked={values.customerType === "Y"}
                              onChange={(e: any) => {
                                handleChange(e);
                                setSelectCustomerType('Y');
                                setFieldValue("categoryValue", "");
                                setFieldValue("categoryLabel", "");
                                setSelectCategory("");
                                setFieldValue("subCategoryValue", "");
                                setFieldValue("subCategoryLabel", "");
                                setSelectSubCategory("");
                                const filterFixedInputs = filteredFixedInputs();
                                setDynamicColumnData(filterFixedInputs);
                              }}
                            />
                            <RadioBtn
                              label="Non-Existing Customer"
                              name="customerType"
                              className="me-3"
                              value="N"
                              checked={values.customerType === "N"}
                              onChange={(e: any) => {
                                handleChange(e);
                                setSelectCustomerType('N');
                                setFieldValue("categoryValue", "");
                                setFieldValue("categoryLabel", "");
                                setSelectCategory("");
                                setFieldValue("subCategoryValue", "");
                                setFieldValue("subCategoryLabel", "");
                                setSelectSubCategory("");
                                setFieldValue("ticketType", "S");
                                setSelectTicketType('S')
                                const filterFixedInputs = filteredFixedInputs();
                                setDynamicColumnData(filterFixedInputs);
                              }}
                            />
                          </div>
                        </Col>

                        <Col md={6} className='mt-3 mt-md-0'>
                          <label className='text-xs text-slate-500 required'>Ticket Type</label>
                          <div className="d-flex">
                            {ticketTypeSequence.map((items: any, id: number) => (
                              <React.Fragment key={id}>
                                {items === 1 && <RadioBtn
                                  label="Service"
                                  name="ticketType"
                                  className="me-3"
                                  value="S"
                                  checked={values.ticketType === "S"}
                                  onChange={(e: any) => { handleChange(e); setSelectTicketType('S') }}
                                />
                                }
                                {items === 2 &&
                                  <>
                                    {values.customerType === "Y" &&
                                      <RadioBtn
                                        label="Transaction"
                                        name="ticketType"
                                        className="me-3"
                                        value="T"
                                        checked={values.ticketType === "T"}
                                        onChange={(e: any) => { handleChange(e); setSelectTicketType('T') }}
                                      />
                                    }
                                  </>
                                }
                              </React.Fragment>
                            ))}
                          </div>
                        </Col>

                        <Col md={6} className="mt-3">
                          <Select
                            name="categoryValue"
                            placeholder="Category *"
                            className="select-form"
                            required
                            options={[{ value: "", label: "Select Category" }, ...getCategoryData.map((items) => ({
                              value: items.TranCode, label: items.CategoryName, assignType: items.CategoryType, tranDtl: items.TranDetail, cardDtl: items.CardDetail
                            }))]}
                            components={{
                              ValueContainer: CustomValueContainer
                            }}
                            tabIndex={1}
                            value={values.categoryValue !== "" && {
                              value: values.categoryValue,
                              label: values.categoryLabel
                            }}
                            onChange={(e: any) => { setFieldValue("categoryValue", e?.value); setFieldValue("categoryLabel", e?.label); setSelectCategory(e?.value); setFieldValue("subCategoryValue", ""); setFieldValue("subCategoryLabel", ""); setSelectSubCategory(""); }}
                            styles={{
                              valueContainer: (provided, state) => ({
                                ...provided,
                                overflow: "visible"
                              }) as any,
                              placeholder: (provided, state) => ({
                                ...provided,
                                position: "absolute",
                                paddingRight: 3,
                                paddingLeft: 3,
                                top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                                backgroundColor:
                                  state.hasValue || state.selectProps.inputValue
                                    ? "white"
                                    : "transparent",
                                transition: "top 0.3s, font-size 0.3s",
                                fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                              }) as any
                            }}
                          />
                          <ErrorMessage name="categoryValue" className='error-msg' component="div" />
                        </Col>

                        <Col md={6} className='mt-3'>
                          <Select
                            name="subCategoryValue"
                            className="select-form"
                            placeholder={`Sub-Category ${ticketSubCategoryMandentoryFlag === "Y" ? "*" : ""}`}
                            required={ticketSubCategoryMandentoryFlag === "Y"}
                            components={{
                              ValueContainer: CustomValueContainer
                            }}
                            options={[{ value: "", label: "Select Sub-Category" }, ...getSubCategoryData.map((items) => ({
                              value: items.TranCode, label: items.SubCategoryName, categoryCode: items.CategoryCode, categoryNm: items.CategoryName, tranDtl: items.TranDetail, cardDtl: items.CardDetail
                            }))]}
                            tabIndex={2}
                            value={values.subCategoryValue !== "" && {
                              value: values.subCategoryValue,
                              label: values.subCategoryLabel
                            }}
                            onChange={(e: any) => { setFieldValue("subCategoryValue", e?.value); setFieldValue("subCategoryLabel", e?.label); setSelectSubCategory(e?.value) }}
                            styles={{
                              valueContainer: (provided, state) => ({
                                ...provided,
                                overflow: "visible"
                              }) as any,
                              placeholder: (provided, state) => ({
                                ...provided,
                                position: "absolute",
                                paddingRight: 3,
                                paddingLeft: 3,
                                top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                                backgroundColor:
                                  state.hasValue || state.selectProps.inputValue
                                    ? "white"
                                    : "transparent",
                                transition: "top 0.3s, font-size 0.3s",
                                fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                              }) as any
                            }}
                          />
                          <ErrorMessage name="subCategoryValue" className='error-msg' component="div" />
                        </Col>

                        <Col md={12}>
                          <FetchDynamicColumn data={dynamicColumnData} fetchSubDynamicColumn={fetchDynamicColumn} getDynamicInputColumnValue={getDynamicInputColumnValue} />
                        </Col>

                        {values.customerType === "Y" && isShowBranchCombo === "Y" &&
                          <Col md={6} className='mt-3'>
                            <Select
                              name="branchValue"
                              className="select-form"
                              placeholder="Branch *"
                              required
                              components={{
                                ValueContainer: CustomValueContainer
                              }}
                              options={[{ value: "", label: "Select Branch" }, ...getBranchData.map((items) => ({
                                value: items.BranchCode, label: items.BranchName
                              }))]}
                              value={values.branchValue !== "" && {
                                value: values.branchValue,
                                label: values.branchLabel
                              }}
                              onChange={(e: any) => { setFieldValue("branchValue", e?.value); setFieldValue("branchLabel", e?.label); }}
                              styles={{
                                valueContainer: (provided, state) => ({
                                  ...provided,
                                  overflow: "visible"
                                }) as any,
                                placeholder: (provided, state) => ({
                                  ...provided,
                                  position: "absolute",
                                  paddingRight: 3,
                                  paddingLeft: 3,
                                  top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                                  backgroundColor:
                                    state.hasValue || state.selectProps.inputValue
                                      ? "white"
                                      : "transparent",
                                  transition: "top 0.3s, font-size 0.3s",
                                  fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                                }) as any
                              }}
                            />
                            <ErrorMessage name="branchValue" className='error-msg' component="div" />
                          </Col>
                        }

                        <Col md={6} className='mt-3'>
                          <Select
                            name="classificationValue"
                            className="select-form"
                            required
                            components={{
                              ValueContainer: CustomValueContainer
                            }}
                            options={[
                              { value: "Q", label: "Question" },
                              { value: "P", label: "Problem" },
                              { value: "F", label: "Feature" },
                              { value: "O", label: "Other" },
                            ]}
                            placeholder='Classification *'
                            value={values.classificationValue !== "" && {
                              value: values.classificationValue,
                              label: values.classificationLabel
                            }}
                            onChange={(e: any) => { setFieldValue("classificationValue", e?.value); setFieldValue("classificationLabel", e?.label) }}
                            styles={{
                              valueContainer: (provided, state) => ({
                                ...provided,
                                overflow: "visible"
                              }) as any,
                              placeholder: (provided, state) => ({
                                ...provided,
                                position: "absolute",
                                paddingRight: 3,
                                paddingLeft: 3,
                                top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                                backgroundColor:
                                  state.hasValue || state.selectProps.inputValue
                                    ? "white"
                                    : "transparent",
                                transition: "top 0.3s, font-size 0.3s",
                                fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                              }) as any
                            }}
                          />
                          <ErrorMessage name="classificationValue" className='error-msg' component="div" />
                        </Col>

                        <Col md={6} className='mt-3'>
                          <Select
                            name="priorityValue"
                            className="select-form"
                            required
                            components={{
                              ValueContainer: CustomValueContainer
                            }}
                            options={[
                              { value: "H", label: "High" },
                              { value: "M", label: "Medium" },
                              { value: "L", label: "Low" },
                            ]}
                            placeholder="Priority *"
                            value={values.priorityValue !== "" && {
                              value: values.priorityValue,
                              label: values.priorityLabel
                            }}
                            onChange={(e: any) => { setFieldValue("priorityValue", e?.value); setFieldValue("priorityLabel", e?.label) }}
                            styles={{
                              valueContainer: (provided, state) => ({
                                ...provided,
                                overflow: "visible"
                              }) as any,
                              placeholder: (provided, state) => ({
                                ...provided,
                                position: "absolute",
                                paddingRight: 3,
                                paddingLeft: 3,
                                top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                                backgroundColor:
                                  state.hasValue || state.selectProps.inputValue
                                    ? "white"
                                    : "transparent",
                                transition: "top 0.3s, font-size 0.3s",
                                fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                              }) as any
                            }}
                          />
                          <ErrorMessage name="priorityValue" className='error-msg' component="div" />
                        </Col>

                        {values.ticketType === "T" &&
                          <Col md={12}>
                            <Table bordered hover className="mt-3">
                              <thead>
                                <tr>
                                  <th className="text-slate-700 text-sm  text-start">Trn. Ref. No.</th>
                                  <th className="text-slate-700 text-sm text-center">Trn. Date</th>
                                  <th className="text-slate-700 text-sm text-end">Amount</th>
                                  <th className="text-slate-700 text-sm text-center" style={{ width: 30 }}>
                                    <Button variant="edit" className="rounded-circle btn-sm" onClick={() => {
                                      var transactionRow = [...values.transcationDtl];

                                      if (values.transcationDtl.length < Number(transactionRowLimit)) {
                                        if (transactionRow[transactionRow.length - 1].TranRefNo !== '' && transactionRow[transactionRow.length - 1].TranAmount !== '' && transactionRow[transactionRow.length - 1].TranDate !== '') {
                                          setFieldValue('transcationDtl', [...values.transcationDtl, { TranRefNo: '', TranAmount: '', TranDate: '' }])
                                        } else {
                                          toastNotify('Please fill value', 'error');
                                        }
                                      } else {
                                        toastNotify(`Maximun ${transactionRowLimit} dransaction details added`, 'error');
                                      }
                                    }}><BiPlus /></Button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {values.transcationDtl.map((items, id) => (
                                  <tr key={id}>
                                    <td>
                                      <input
                                        type='text'
                                        className="w-100 form-control"
                                        value={items.TranRefNo}
                                        disabled={addTicketLoader}
                                        maxLength={20}
                                        onChange={(e) => {
                                          let newValue = [...values.transcationDtl];
                                          newValue[id].TranRefNo = e.target.value;
                                          setFieldValue('transcationDtl', newValue);
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <Flatpickr
                                        className="form-control text-center"
                                        id="dateRange"
                                        options={{
                                          dateFormat: "d/m/Y",
                                          minDate: moment().subtract(Number(process.env.REACT_APP_MIN_TRNSACTION_DAYS), 'days').format('DD/MM/YYYY'),
                                          maxDate: moment().format("DD/MM/YYYY"),
                                        }}
                                        name='dateRange'
                                        disabled={addTicketLoader}
                                        value={items.TranDate}
                                        onChange={(e: any) => {
                                          let newValue = [...values.transcationDtl];
                                          newValue[id].TranDate = e[0];
                                          setFieldValue('transcationDtl', newValue);
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type='text'
                                        className="w-100 form-control text-end"
                                        value={items.TranAmount}
                                        maxLength={15}
                                        disabled={addTicketLoader}
                                        onFocus={() => {
                                          let newValue = [...values.transcationDtl];
                                          if (newValue[id].TranAmount === "0.00" || newValue[id].TranAmount === "0") {
                                            newValue[id].TranAmount = "";
                                            setFieldValue('transcationDtl', newValue);
                                          }
                                        }}
                                        onChange={(e) => {
                                          let newValue = [...values.transcationDtl];
                                          e.preventDefault();
                                          const { value } = e.target;
                                          const regex = /^[0-9]*[.,]?[0-9]*$/;
                                          if (regex.test(value.toString())) {
                                            newValue[id].TranAmount = value;
                                            setFieldValue('transcationDtl', newValue);
                                          }
                                        }}
                                        onBlur={(e: any) => {
                                          handleBlur(e);
                                          let newValue = [...values.transcationDtl];
                                          const { value } = e.target;
                                          var lsAmount = parseFloat(value).toFixed(2);
                                          if (isNaN(Number(lsAmount))) {
                                            lsAmount = "0.00";
                                          }
                                          newValue[id].TranAmount = lsAmount;
                                          setFieldValue('transcationDtl', newValue);
                                        }}
                                      />
                                    </td>

                                    <td>
                                      {values.transcationDtl.length > 1 &&
                                        <Button variant="delete" className="rounded-circle btn-sm" onClick={() => {
                                          let newValue = [...values.transcationDtl];
                                          newValue.splice(id, 1);
                                          setFieldValue('transcationDtl', newValue);
                                        }}><BiTrash /></Button>
                                      }
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Col>
                        }

                        <Col md={12} lg={12} className=" mt-3 d-flex align-items-center gap-2">
                          <Checkbox
                            name="status"
                            label="Do you want to use template."
                            value={isTemplate}
                            onChange={(e: any) => { setIsTemplate(e.target.checked); setFieldValue("subject", ""); setFieldValue("ticketDescription", ""); setFieldValue("templateValue", ""); setFieldValue("templateLabel", "") }}
                          />
                        </Col>

                        {isTemplate &&
                          <Col md={6} lg={6} className='mt-3'>
                            <SelectField
                              name="template"
                              options={getTemplateDropdownData.map((items: any) => ({
                                value: items.TranCode, label: items.TemplateName, Subject: items.Subject, Description: items.Description
                              }))}
                              placeholder="Templates"
                              value={values.templateValue !== "" && {
                                value: values.templateValue,
                                label: values.templateLabel
                              }}
                              onChange={(e: any) => { setFieldValue("templateValue", e?.value); setFieldValue("templateLabel", e?.label); setFieldValue("subject", e?.Subject); setFieldValue("ticketDescription", e?.Description) }}
                              onBlur={handleBlur}
                            />
                          </Col>
                        }

                        <Col md={12} className='mt-3'>
                          <Textfield
                            label="Subject"
                            name="subject"
                            id="subject"
                            size="small"
                            required
                            maxLength={200}
                            value={values.subject}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage name="subject" className='error-msg' component="div" />
                        </Col>

                        <Col md={12} className=" mt-3">
                          <Editor
                            label="Description"
                            required
                            placeholder="write your content ...."
                            value={values.ticketDescription}
                            onChange={(e: any) => setFieldValue("ticketDescription", e)}
                          />
                          <ErrorMessage name="ticketDescription" className='error-msg' component="div" />
                        </Col>


                        <Col md={6} className='mt-3'>
                          <input
                            type="file"
                            name="attachFile"
                            multiple
                            className="d-none"
                            ref={attanchmentRef}
                            accept={`.png,.jpeg,.jpg,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.eml,.msg,${bypassToMimeType === "Y" ? ".txt" : ""}`}
                            onChange={(e: any) => {
                              e.preventDefault();
                              handleMultiFile(e)
                            }}
                          />

                          <span
                            className="d-flex align-items-center"
                            onClick={attachfiles}
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="border rounded-circle d-flex justify-content-center align-items-center me-2 border-oragne"
                              style={{ width: 35, height: 35 }}
                            >
                              <BiLink className="text-oragne" />
                            </div>
                            <div>
                              <h5 className="text-sm mb-0">
                                Attach a file
                              </h5>
                              <div className="text-xs text-slate-500">Up to {attechmentSize} MB</div>
                            </div>
                          </span>

                          <div className='mt-3'>
                            {multiFile.map((file: any, id: number) => {
                              const fileSize: any = file.size >= 1024 ? (file.size / 1048576).toFixed(2) + " MB" : (file.size / 1024).toFixed(2) + " KB"
                              return (
                                <div
                                  key={id}
                                  className="d-flex align-items-center mt-3"
                                >
                                  {file.type === "image" ?
                                    <div
                                      className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                      style={{ width: 35, height: 35 }}
                                    >
                                      <img src={file ? URL.createObjectURL(file) : ""} alt={file.name} className="w-100 h-100 rounded-circle" />
                                    </div>
                                    :
                                    <div
                                      className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                      style={{ width: 35, height: 35 }}
                                    >
                                      <BiFile />
                                    </div>
                                  }
                                  <div>
                                    <h5 className="text-sm mb-1">{file.name}</h5>
                                    <div className="text-xs text-slate-500">File Size : {fileSize}</div>
                                  </div>
                                  <Button variant='outline-danger' className='rounded-circle btn-sm ms-auto'
                                    onClick={() => {
                                      let newValue = [...values.attachFile];
                                      newValue.splice(id, 1);
                                      setFieldValue('attachFile', newValue);

                                      let selectedFile = [...multiFile];
                                      selectedFile.splice(id, 1);
                                      setMultiFile(selectedFile);
                                    }}>
                                    <BiTrash className="text-danger" />
                                  </Button>
                                </div>
                              )
                            })}
                          </div>

                        </Col>

                        <Col md={12} className='mt-3'>
                          <Checkbox
                            name="agreeTicket"
                            label="I declare that information provided is accurate and complete to the best of my knowledge. I hereby authorize Bank to use / share the information with its affiliates /subsidiaries / third party vendors, as per requirement."
                            value={values.agreeTicket}
                            onChange={handleChange}
                          />
                        </Col>

                        <Col md={12} className='mt-3 d-flex justify-content-end '>
                          <Button
                            type="button"
                            variant="outline-danger"
                            className="btn-sm me-2"
                            onClick={() => {
                              resetForm();
                              const filterFixedInputs = filteredFixedInputs();
                              setDynamicColumnData(filterFixedInputs);
                              setSelectCategory("");
                              setSelectSubCategory("");
                              setIsTemplate(false)
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" className="btn-sm" variant="orange" disabled={addTicketLoader}>
                            {!addTicketLoader ? 'Submit' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                          </Button>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={3} className={`${articleList.length !== 0 ? "d-md-block" : "d-none "}`}>
                      <div>
                        <h1 className="text-base pb-2 fw-semibold mb-2 border-bottom">
                          Articles
                        </h1>
                        {!isArticleLoader ?
                          <>
                            {articleList.length !== 0 ?
                              <ul style={{ listStyle: "none" }} className="ps-0">
                                {articleList.map((data: any, id: number) => (
                                  <li key={id} className="d-flex align-items-center gap-2 mt-2 text-sm article-list" onClick={() => { setIsArticle(!isArticleDtl); setSelectedArticle(data) }}>
                                    <BiFile />
                                    <div style={{ width: "100%", textOverflow: "ellipsis", overflow: "hidden", textWrap: "nowrap" }}>{data.Topic}</div>
                                  </li>
                                ))}
                              </ul>
                              :
                              <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
                                <div>
                                  <img src="/imgaes/svg/55024593_9264820.svg" alt="No Data Found" style={{ width: 150 }} />
                                  <h1 className="text-base text-center">No article found</h1>
                                </div>
                              </div>
                            }
                          </>
                          :
                          <div style={{ height: '40vh' }} className='d-flex justify-content-center align-items-center'>
                            <Loader />
                          </div>
                        }

                      </div>
                    </Col>
                  </Row>
                </form>
              )
            }}
          </Formik>
        </Card.Body>
      </Card>

      {isArticleDtl &&
        <ArticleDtlMdl isArticleDtl={isArticleDtl} setIsArticle={setIsArticle} data={selectedArticle} setSelectedArticle={setSelectedArticle} />
      }
    </div >
  );
};

export default Createticket;




